import Mark from 'mark.js'
import debounce from 'lodash/debounce'

export default (name, prefillValue, searchValue, offset = null) => ({
    fieldName: name,
    offset,
    selectedValue: prefillValue,
    modelValue: searchValue,
    suggestions: [],
    showResults: false,
    selectedIndex: null,
    setSelectedIndex(index) {
        this.selectedIndex = index
    },
    resetSelectedIndex() {
        this.selectedIndex = null
    },
    selectNextIndex() {

        if (this.selectedIndex === null || this.selectedIndex === this.suggestions.length - 1) {
            this.selectedIndex = 0
        } else {
            this.selectedIndex++
        }

    },
    selectPreviousIndex() {

        if (this.selectedIndex === null || this.selectedIndex === 0) {
            this.selectedIndex = this.suggestions.length - 1
        } else {
            this.selectedIndex--
        }

    },
    async handleSearch() {

        if (!this.modelValue?.length) {

            this.modelValue = null
            this.suggestions = []
            this.$store.webForm.component.setFieldFormData(this.fieldName, null, this.offset)

            return

        }

        // Prevent search if the current value is the same as the selected value
        if (this.selectedValue && this.modelValue === Object.values(this.selectedValue).filter(Boolean).join(', ')) {
            return
        }

        try {

            const lookup = new this.$store.smartyLookup(this.modelValue)
            const response = await this.$store.smartyClient.send(lookup)

            if (response?.result?.length) {

                this.suggestions = response.result.splice(0, 7)
                this.showResults = true
                this.persistTypedAddress()

            } else {
                this.persistTypedAddress()
            }

        } catch (error) {

            this.suggestions = []
            this.persistTypedAddress()

        }

    },
    debouncedHandleSearch: null,
    persistTypedAddress() {

        this.$store.webForm.component.setFieldFormData(this.fieldName, { address: this.modelValue }, this.offset)
        this.$store.webForm.state.canSubmit = true

    },
    itemTemplate(suggestion) {

        return [ suggestion.streetLine, suggestion.city, suggestion.state, suggestion.zipcode ]
            .filter(Boolean)
            .join(', ')

    },
    highlightResults() {

        if (!this.modelValue?.length) {
            return
        }

        const instance = new Mark(this.$refs.results)

        instance.mark(this.modelValue)

    },
    handleEnterKey() {

        if (this.selectedIndex === null) {
            return
        }

        this.setValue(this.suggestions[ this.selectedIndex ])

    },
    setValue(suggestion) {

        this.modelValue = this.itemTemplate(suggestion)

        this.selectedValue = {
            address: suggestion.streetLine,
            city: suggestion.city,
            state: suggestion.state,
            zip: suggestion.zipcode,
        }

        this.$store.webForm.component.setFieldFormData(this.fieldName, this.selectedValue, this.offset)

        this.$nextTick(() => {

            this.showResults = false
            this.$store.webForm.state.canSubmit = true

        })

    },
    async init() {

        this.debouncedHandleSearch = debounce(this.handleSearch, 300)
        this.$watch('modelValue', () => this.debouncedHandleSearch())

        this.$watch('selectedValue', value => {

            this.$store.webForm.component.setFieldFormData(this.fieldName, value, this.offset)

            if (this.form) {
                this.form.address = this.selectedValue
            }

        })

        this.$watch('suggestions', () => this.highlightResults())
        this.$watch('showResults', show => !show ? null : this.resetSelectedIndex())

        if (this.selectedValue) {
            this.$store.webForm.component.setFieldFormData(this.fieldName, this.selectedValue, this.offset)
        }

    },
})
